import { Component, Input, OnChanges, SimpleChanges, effect } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VoucherTemplateComponent } from '@core/components/voucher-template/components/voucher-template.component';
import type { VoucherTemplateInput } from '@core/components/voucher-template/components/voucher-template.interface';
import { CashProcessorService } from '@core/services/cash-processor.service';
import type { GetPaymentResponseRequest } from '@core/services/cash-processor.interface';
import type { InstructionStepper } from '@core/components/instruction-stepper/instruction-stepper.interfaces';
import type { LinearStepInfo } from '@core/components/linear-step-info/linear-step-info.interfaces';

@Component({
  selector: 'dcv-voucher-pdf-container',
  standalone: true,
  imports: [CommonModule, VoucherTemplateComponent],
  templateUrl: './voucher-pdf-container.component.html',
  styleUrl: './voucher-pdf-container.component.scss',
})
export class VoucherPdfContainerComponent implements OnChanges {
  @Input({ required: true }) linearStep: LinearStepInfo[] = []
  @Input() color!: string;
  VoucherTemplateInput = null as any;
  pdfVoucher: VoucherTemplateInput = null as any
  voucherData: GetPaymentResponseRequest = null as unknown as any;

  constructor(
    private cashProcessorService: CashProcessorService,
  ) {
    effect(() => {
      if (this.cashProcessorService.paymentData().voucherConfig) {
        this.voucherData = { ...this.cashProcessorService.paymentData(), voucherConfig: JSON.parse(this.cashProcessorService.paymentData()?.voucherConfig as unknown as any) }
        this.pdfVoucher = this.initPdfVoucher()
      }
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['linearStep']) {
      this.pdfVoucher = this.initPdfVoucher()
    }
  }

  initPdfVoucher() {
    let paymentInstructions: any;
    let generalInstructions: InstructionStepper[] = []

    this.voucherData?.voucherConfig?.bankList?.forEach(bank => {
      const instrucciones = bank?.paymentMethodInstructions?.map((i) => {
        return i?.instructions?.map((instruction) => {
          return {
            step: instruction?.order,
            description: instruction?.value,
          } as unknown as InstructionStepper
        })
      })[0] as unknown as InstructionStepper[];

      paymentInstructions = [{
        bank: bank?.bankCode,
        hexColor: bank?.hexColor,
        instruction: instrucciones
      }]

      generalInstructions = instrucciones
    });

    return {
      LinearStepInfo: this.linearStep,
      paymentInstructions,
      generalInstructions
    }
  }
}
